import throttle from 'lodash.throttle';
import { useEffect, useRef, useState } from 'react';

const ERROR_RATE = 2;

interface State {
  isLeft: boolean;
  isRight: boolean;
}

const initialState = {
  isLeft: false,
  isRight: false,
};

export const useDetectShadow = () => {
  const [state, setState] = useState<State>(initialState);

  const ref = useRef<HTMLInputElement>(null);

  const detectShadow = (element: HTMLDivElement | null) => {
    if (element != null && element.scrollWidth >= element.offsetWidth) {
      const diff = element.scrollWidth - element.offsetWidth;

      if (element.scrollLeft === 0) {
        setState({ isLeft: false, isRight: true });
      } else if (
        element.scrollLeft > 0 &&
        element.scrollLeft + ERROR_RATE < diff
      ) {
        setState({ isLeft: true, isRight: true });
      } else {
        setState({ isLeft: true, isRight: false });
      }
    }
  };

  const throttledFunc = throttle(detectShadow, 400, { leading: true });

  useEffect(() => {
    const el = ref.current;

    if (el === null) return;

    const handleScroll = () => throttledFunc(el);

    detectShadow(el);
    el.addEventListener('scroll', handleScroll);
    return () => {
      el.removeEventListener('scroll', handleScroll);
    };
    // eslint-disable-next-line
  }, []);

  return { ref, ...state };
};
